import { useTranslation } from 'react-i18next';
import TopAppBar from '../../components/feature/TopAppBar';
import BottomTabBar from '../../components/feature/BottomTabBar';

export default function Notifications() {
  const { t } = useTranslation();
  
  const notifications = [
    {
      id: 1,
      type: 'new_job',
      title: t('newOrderAvailable'),
      message: 'Order #DOM2852 från Domino\'s Stockholm City',
      time: `2 ${t('minAgo')}`,
      icon: 'ri-file-list-3-line',
      color: 'bg-blue-100 text-blue-600',
      unread: true,
    },
    {
      id: 2,
      type: 'cancelled',
      title: t('orderCancelled'),
      message: 'Order #DOM2848 har avbrutits av kunden',
      time: `15 ${t('minAgo')}`,
      icon: 'ri-close-circle-line',
      color: 'bg-red-100 text-red-600',
      unread: true,
    },
    {
      id: 3,
      type: 'bonus',
      title: t('bonusEarned'),
      message: 'Du har tjänat 50 SEK bonus för snabb leverans',
      time: `1 ${t('hourAgo')}`,
      icon: 'ri-trophy-line',
      color: 'bg-green-100 text-green-600',
      unread: false,
    },
    {
      id: 4,
      type: 'message',
      title: t('messageFromCustomer'),
      message: 'Erik Andersson: "Tack för snabb leverans!"',
      time: `2 ${t('hoursAgo')}`,
      icon: 'ri-message-3-line',
      color: 'bg-purple-100 text-purple-600',
      unread: false,
    },
    {
      id: 5,
      type: 'promo',
      title: t('weekendCampaign'),
      message: 'Dubbla poäng på alla leveranser denna helg!',
      time: `3 ${t('hoursAgo')}`,
      icon: 'ri-gift-line',
      color: 'bg-amber-100 text-amber-600',
      unread: false,
    },
    {
      id: 6,
      type: 'completed',
      title: t('deliveryCompleted'),
      message: 'Order #DOM2847 har markerats som levererad',
      time: `4 ${t('hoursAgo')}`,
      icon: 'ri-checkbox-circle-line',
      color: 'bg-green-100 text-green-600',
      unread: false,
    },
  ];
  
  const categories = [t('all'), t('orders'), t('messages'), t('promotions')];
  
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <TopAppBar title={t('notifications')} />
      
      <div className="pt-14 px-4">
        <div className="flex gap-2 mb-4 mt-4 overflow-x-auto pb-2">
          {categories.map((category, index) => (
            <button
              key={category}
              className={`px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all ${
                index === 0
                  ? 'bg-[#E31837] text-white'
                  : 'bg-white text-gray-700 border border-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
        
        <div className="space-y-3">
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className={`bg-white rounded-2xl p-4 shadow-md border-2 transition-all ${
                notification.unread ? 'border-[#E31837]' : 'border-gray-100'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${notification.color}`}>
                  <i className={`${notification.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <h3 className="text-sm font-bold text-gray-900">{notification.title}</h3>
                    {notification.unread && (
                      <div className="w-2 h-2 bg-[#E31837] rounded-full flex-shrink-0 mt-1"></div>
                    )}
                  </div>
                  <p className="text-sm text-gray-700 mb-2">{notification.message}</p>
                  <p className="text-xs text-gray-500">{notification.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <BottomTabBar />
    </div>
  );
}
